import { lazy } from "react";

// React.lazy that survives a deploy. Every build renames its code chunks; a
// tab (or the service worker's cached shell) from BEFORE a deploy asks for the
// old names, which no longer exist, the import rejects, and with nothing to
// catch it React blanked the page a second after it loaded (owner report,
// Oct 27 2026). On a failed chunk this reloads the page ONCE to pick up the
// new build. The flag stops a loop if the chunk is genuinely missing (then
// the error is rethrown). The flag is cleared on the next successful load.
// Storage can throw (private windows, blocked storage); then it just rethrows.
export const RELOAD_FLAG = "stinte_chunk_reload";

export function loadWithReload(load, { storage = window.sessionStorage, reload = () => window.location.reload() } = {}) {
  return load()
    .then((module) => {
      try { storage.removeItem(RELOAD_FLAG); } catch { /* storage unavailable */ }
      return module;
    })
    .catch((err) => {
      let alreadyReloaded = true;
      try {
        alreadyReloaded = storage.getItem(RELOAD_FLAG) === "1";
        if (!alreadyReloaded) storage.setItem(RELOAD_FLAG, "1");
      } catch { /* storage unavailable: don't risk a loop */ }
      if (alreadyReloaded) throw err;
      reload();
      // Never settles: the page is reloading.
      return new Promise(() => {});
    });
}

export function lazyWithReload(load) {
  return lazy(() => loadWithReload(load));
}
